import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import './App.css';
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        
        <Weather defaultCity="New York"/>
        
        <footer>
          This site was coded by{" "}
          <a
            href="https://www.vstarcoaching.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            vanessa gil{" "}
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/vanessavgil/veronique-react-weather"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on github
          </a>
        </footer>
      </div>
    </div>
  );
}